<template>
  <div class="input-box">
    <div class="drop-down">
      <GSDropDown
        :placeholder="dropdownPlaceholder"
        :items="dropdownItems"
        @changed="dropdownChanged"
      ></GSDropDown>
    </div>
    <div class="input">
      <GSInput
        :placeholder="inputPlaceholder"
        :type="inputType"
        :digitOnly="inputDigitOnly"
        @changed="inputChanged"
      ></GSInput>
    </div>
  </div>
</template>

<script>
import GSDropDown from './GSDropDown'
import GSInput from './GSInput'
import { EVENT } from '@/constants/event'

export default {
  name: 'GSDropDownInput',
  components: {
    GSDropDown,
    GSInput
  },
  props: {
    dropdownPlaceholder: {
      type: String,
      default: ''
    },
    dropdownItems: {
      type: Array
    },
    inputPlaceholder: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputDigitOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dropDownValue: '',
      inputValue: ''
    }
  },
  computed: {
    packedData () {
      return {
        dropdown: this.dropDownValue,
        input: this.inputValue
      }
    }
  },
  methods: {
    inputChanged (newVal) {
      this.inputValue = newVal
      this.$emit(EVENT.CHANGED, this.packedData)
    },
    dropdownChanged (newVal) {
      this.dropDownValue = newVal
      this.$emit(EVENT.CHANGED, this.packedData)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box {
  display: flex;

  .drop-down {
    flex: 35%;
  }

  .input {
    padding-left: 0.9375rem;
    flex: 65%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSDropDownInput.vue